import { Box, Typography, useTheme } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { tokens } from "../theme";

const Error = ({ children = "Une erreur est survenue" }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1,
        py: 4,
        px: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 40, color: colors.redAccent[400] }} />
      <Typography
        variant="body1"
        sx={{ color: colors.grey[100], fontWeight: 600, maxWidth: 420 }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default Error;
